module.exports = __webpack_public_path__ + "static/media/Corp1.05ca3aaa.jpg";